//import { SEOService } from '../../core/seo.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-managed-services',
  templateUrl: './managed-services.component.html',
  styleUrls: ['./managed-services.component.scss']
})
export class RapinnoManagedServicesComponent implements OnInit {

  constructor(
    //private seoService: SEOService
  ) { }

  ngOnInit(): void {
    //this.setSeo();
  }
}
